import React from 'react';
import classNames from 'classnames';
import cls from './ProjectTeamInvite.module.css';
import { useProjectTeamInvite } from './useProjectTeamInvite';
import { ProjectTeamManagersRow } from './Components/ProjectTeamManagersRow/ProjectTeamManagersRow';
import { ProjectTeamForemenRow } from './Components/ProjectTeamForemenRow/ProjectTeamForemenRow';
import { ProjectTeamPurchasersRow } from './Components/ProjectTeamPurchasersRow/ProjectTeamPurchasersRow';
import { EmployersForSelect } from '../../../AddProject/SecondStep/useSecondStep';

interface ProjectTeamInviteProps {
    classes?: string;
    employersList: EmployersForSelect[];
    onEmployersListSet: (value: string) => void;
}

export const ProjectTeamInvite = ({
    classes,
    onEmployersListSet,
    employersList,
}: ProjectTeamInviteProps) => {
    const { openedInviteCard, onOpenedInviteCardChange, closingCard, onSetClosingCard } =
        useProjectTeamInvite();

    return (
        <div className={classNames(cls.ProjectTeamInvite, [classes])}>
            <ProjectTeamManagersRow
                closingCard={closingCard}
                onSetClosingCard={onSetClosingCard}
                onEmployersListSet={onEmployersListSet}
                employersList={employersList}
                openedInviteCard={openedInviteCard}
                onOpenedInviteCardChange={onOpenedInviteCardChange}
            />
            <ProjectTeamForemenRow
                closingCard={closingCard}
                onSetClosingCard={onSetClosingCard}
                onEmployersListSet={onEmployersListSet}
                employersList={employersList}
                openedInviteCard={openedInviteCard}
                onOpenedInviteCardChange={onOpenedInviteCardChange}
            />
            <ProjectTeamPurchasersRow
                closingCard={closingCard}
                onSetClosingCard={onSetClosingCard}
                onEmployersListSet={onEmployersListSet}
                employersList={employersList}
                openedInviteCard={openedInviteCard}
                onOpenedInviteCardChange={onOpenedInviteCardChange}
            />
        </div>
    );
};
